import { IHttpClient } from "../../../../Common/HttpClient/IHttpClient";
import { AuthenticationMode, createAuthenticationProvider } from "../../../../Common/HttpClient/AuthenticationMode";
import { HttpClient } from "../../../../Common/HttpClient/HttpClient";
import { nodeFetch } from "../../../../Common/HttpClient/FetchImplementation/NodeFetch";
import { localCandyApi } from "../../../../Common/EndPoints";

export interface CompileNormalizationRulesResult {
    diagnosticMessages?: string[];
    sourceText?: string;
}

export class ToolsApiClient {
    private readonly httpClient: IHttpClient;

    public constructor(baseUrl?: string, resourceZone?: string, authentication?: AuthenticationMode) {
        this.httpClient = new HttpClient(
            nodeFetch,
            baseUrl ?? localCandyApi,
            createAuthenticationProvider(authentication),
            {
                resourceZone: resourceZone,
            }
        );
    }

    public async compileNormalizationRules(
        rules: string,
        normalizerId?: string
    ): Promise<CompileNormalizationRulesResult> {
        return this.httpClient
            .post(this.getUrl("compile-normalization-rules"))
            .withQueryParams(normalizerId != undefined ? { normalizerId: normalizerId } : {})
            .withJsonBody(rules)
            .json<CompileNormalizationRulesResult>();
    }

    private getUrl(draftRelatedUrl: string): string {
        return `v1/tools/${draftRelatedUrl}`;
    }
}
